export default `
mutation formUploadFiles(
  $form_type: String!,
  $fullname: String!,
  $organization: String,
  $email: String!,
  $telephone: String!,
  $applies: String,
  $description: String,
  $files: [FileInput],
  $items: [ItemInput]
) {
  formUploadFiles(
   input: {form_type: $form_type,
    fullname: $fullname,
    organization: $organization,
    email: $email,
    telephone: $telephone,
    applies: $applies,
    description: $description,
    files: $files
    items: $items
   }
  ) {
    message
  }
}
`;

